export default `/* Ids Modal Component */
:host {
  display: block;
  position: fixed;
  visibility: visible;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

:host(:not([visible])) {
  pointer-events: none;
  visibility: hidden;
}

.ids-modal {
  display: block;
  pointer-events: none;
}
.ids-modal[visible] {
  pointer-events: auto;
}
.ids-modal.fullsize {
  height: 100%;
}
.ids-modal.fullsize .ids-modal-container {
  height: 100% !important;
  min-height: 100% !important;
  max-height: 100% !important;
  width: 100% !important;
}
.ids-modal.fullsize .ids-modal-header + .ids-modal-content {
  overflow-y: auto;
}
.ids-modal:not(.scrollable) .has-scrollbar {
  overflow: hidden;
  padding: 0;
}
.ids-modal.scrollable .has-scrollbar {
  overflow: auto;
}
.ids-modal:not(.fullsize)::part(popup) {
  max-height: calc(100% - 32px);
}

.ids-modal-header {
  padding: var(--ids-modal-header-padding);
}

.ids-modal-content {
  padding: var(--ids-modal-content-padding);
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}

.ids-modal-header + .ids-modal-content {
  padding-block-start: 0;
}

.ids-modal-header,
.ids-modal-footer {
  align-items: center;
  display: flex;
}

.ids-modal-footer {
  margin: var(--ids-modal-footer-margin);
  border-top: 1px solid var(--ids-modal-footer-color-border);
}
.ids-modal-footer[hidden] {
  border-top: none;
}

.ids-modal-container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  width: 100%;
  max-height: calc(100vh - 64px);
}

::slotted([slot=buttons]) {
  flex-grow: 1;
  display: flex;
}

.modal-control-close {
  position: absolute;
  top: var(--ids-space-2xs);
  right: var(--ids-space-2xs);
}
.modal-control-close[dir=rtl] {
  left: var(--ids-space-2xs);
  right: unset;
}

::slotted([slot=buttons]:not(:first-of-type)) {
  border-inline-start: 1px solid var(--ids-modal-footer-color-border);
}

.ids-modal-button:not(.ids-modal-icon-button):not(:first-of-type) {
  border-left: 1px solid var(--ids-modal-footer-color-border);
}

@media screen and (min-width: 767px) {
  ::slotted([slot=title]) {
    font-size: var(--ids-font-size-lg);
  }
}
.ids-modal.ids-about .ids-modal-content.has-scrollbar {
  overflow: auto;
  padding: var(--ids-about-content-padding);
  height: 75%;
}

.ids-about .ids-modal-container {
  max-width: var(--ids-about-width-max);
  min-width: var(--ids-about-width-min);
}
.ids-about .ids-modal-container .modal-control-close {
  z-index: var(--ids-z-index-10);
}
.ids-about .ids-modal-header {
  justify-content: space-evenly;
  flex-direction: column;
  width: calc(100% - 40px);
}
.ids-about .ids-modal-content-wrapper {
  padding-block: 4px;
  padding-inline: 24px;
  margin-block-end: 20px;
  overflow: hidden;
}
.ids-about .ids-modal-content {
  border: 1px solid var(--ids-about-color-border-default);
  padding: var(--ids-about-content-padding);
  margin-block-start: 0;
  margin-block-end: 24px;
  border-radius: var(--ids-border-radius-2xs);
  max-height: 160px;
  outline: 0;
  overflow: auto;
  text-align: left;
  scroll-behavior: smooth;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ids-about .ids-modal-content:focus {
  border-color: var(--ids-about-color-border-focus);
  box-shadow: var(--ids-about-shadow-focus);
  outline: 0;
  outline-color: var(--ids-color-transparent);
}
.ids-about .ids-modal-content:hover {
  border-color: var(--ids-about-color-border-hover);
}

::slotted([slot=product]),
::slotted([slot=content]),
::slotted([slot=copyright]) {
  display: block;
  margin-block-end: 24px;
}

::slotted([slot=icon]) {
  margin-block-end: 4px;
}
::slotted([slot=icon])[icon=logo-white-trademark] {
  margin-block-start: 8px;
  margin-block-end: 8px;
}

::slotted([icon=logo-white-trademark]) {
  margin-block-start: 18px;
  margin-block-end: 8px;
}

::slotted([slot=buttons]) {
  position: absolute;
  top: 4px;
  right: 4px;
}

::slotted([slot=buttons]:not(:first-of-type)) {
  border-left: var(--ids-color-transparent);
}

:host([dir=rtl]) ::slotted([slot=buttons]) {
  left: 4px;
  right: unset;
}
:host([dir=rtl]) .ids-modal-content {
  text-align: right;
}

div.ids-modal {
  pointer-events: initial;
}

@media (max-width: 767px) {
  div.ids-modal {
    margin-left: calc(300px - 50%);
    margin-right: 5%;
  }
  .ids-about .ids-modal-content {
    max-height: 400px;
  }
}
#copy-to-clipboard {
  position: absolute;
  right: 4px;
  bottom: 7px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
